import { reactive, ref } from 'vue';

import { memoize } from '@/helpers/memoize/memoize';
import { useCountry } from '@/hooks/use-country/use-country';
import { getGrowthBookFeatureValue, GrowthBookFeatures } from '@/services/growth-book/growth-book';
import { dispatch, getState } from '@/store/store-helper';

// const fetchMyProfileFull = memoize(() => dispatch('actionMyProfileGetFull'));

export function useSplit<T extends keyof GrowthBookFeatures>(featureName: T) {
  const variant = ref<GrowthBookFeatures[T]>('def');
  const isInited = ref(false);
  const isV2 = ref(false);

  async function init() {
    const country = useCountry();

    try {
      try {
        await country.load();
      } finally {
        const profileFull =
          getState().myProfile.full ?? (await memoize(dispatch)('actionMyProfileGetFull'));

        variant.value = (await getGrowthBookFeatureValue(featureName, 'def', {
          countryAlpha2: country.country.value?.country.isoCodeAlpha2,
          regDateUnix: profileFull.timeCreated,
        })) as GrowthBookFeatures[T];
        isV2.value = variant.value === 'v2';
      }
    } finally {
      isInited.value = true;
    }
  }

  return reactive({
    variant,
    isInited,
    isV2,
    init,
  });
}
